export type HubSection='development'|'releases'|'status'
export const hubSections=[{key:'development',label:'מחלקת פיתוח'},{key:'releases',label:'שחרורים'},{key:'status',label:'מצב'}] as const
export function hubSection(path:string):HubSection{return path.startsWith('/command/releases')?'releases':path.startsWith('/command/status')?'status':'development'}
export function legacyHubLocation(path:string,search='',hash=''){
 path=path.replace(/\/+$/,'')||'/'
 const query=new URLSearchParams(search)
 let section:HubSection='development'
 if((path==='/command'||path==='/command/development')&&query.get('view')==='releases'){section='releases';query.delete('view')}
 else if((path==='/command'||path==='/command/development')&&query.get('view')==='model-report'){query.delete('view');query.set('hubView','agents');query.set('agentsView','models')}
 else if(path==='/releases')section='releases'
 else if(path==='/ai-usage'){query.set('hubView','agents');query.set('agentsView','usage')}
 else if(['/monitor','/health','/services-monitor','/systems','/infrastructure'].includes(path)){
  section='status';query.set('statusView','monitor')
  if(path==='/health'||path==='/infrastructure')query.set('tab','infra')
  if(path==='/services-monitor')query.set('tab','faults')
 }
 return `/command/${section}${query.size?'?'+query.toString():''}${hash}`
}
export function hubLink(section:HubSection,values:Record<string,string>={}){const query=new URLSearchParams(values);return `/command/${section}${query.size?'?'+query.toString():''}`}
